import { Link, useNavigate } from "react-router-dom";
import { DietaryPreference } from "../../../../models";
import { createDietaryPreference, State } from "../actions";
import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import { Button } from "../../../../components/button";

export default function DietaryPreferenceCreateForm() {
  const navigate = useNavigate();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };

  const [state, formAction, isPending] = useActionState(
    createDietaryPreference,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate("/admin/dietary-preferences");
    }
  }, [state]);

  return (
    <form className="space-y-6 max-w-3xl py-8 text-left" action={formAction}>
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Dietary Preference Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            placeholder="Enter dietary preference name"
            aria-describedby="name-error"
            defaultValue={state.defaultValues.name ?? ""}
            required
          />
          <FormError id="name-error" message={state.errors?.name} />
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <Link to="/admin/dietary-preferences">
          <Button type="reset" disabled={isPending}>
            Cancel
          </Button>
        </Link>
        <Button
          type="submit"
          disabled={isPending}
          loading={isPending}
          className="min-w-[90px]"
        >
          Save Changes
        </Button>
      </div>
    </form>
  );
}



